import { render, staticRenderFns } from "./EmployeeAttachments.vue?vue&type=template&id=50b8db32&scoped=true&"
import script from "./EmployeeAttachments.vue?vue&type=script&lang=js&"
export * from "./EmployeeAttachments.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAttachments.vue?vue&type=style&index=0&id=50b8db32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b8db32",
  null
  
)

export default component.exports